"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const dnaR_datePicker_model_1 = require("./dnaR-datePicker.model");
const datepicker_1 = require("@angular/material/datepicker");
const dnaR_datePicker_header_component_1 = require("./dnaR-datePicker-header.component");
const core_2 = require("@angular/material/core");
const moment = require("moment");
const forms_1 = require("@angular/forms");
const i0 = require("@angular/core");
const i1 = require("@angular/common");
const i2 = require("@angular/material/datepicker");
const i3 = require("@angular/material/form-field");
const _c0 = ["datepickerActions"];
const _c1 = ["datePicker"];
function DnaRDatePicker_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentError, " ");
} }
const _c2 = function (a0, a1, a2) { return { "disabled": a0, "invalid": a1, "valid": a2 }; };
const _c3 = function (a0) { return { "disabled": a0 }; };
/* Required for form validation */
exports.DATEPICKER_CONTROL_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(() => DnaRDatePicker),
    multi: true
};
class DnaRDatePicker {
    constructor(cdRef) {
        this.cdRef = cdRef;
        this.hasError = false;
        this.dnaRDatePickerHeaderComponent = dnaR_datePicker_header_component_1.DnaRDatePickerHeaderComponent;
        this.currentControlName = null;
        this.isDuplicate = false;
        this.duplicate = false;
        this.isDisabled = false;
        this.disabled = false;
        this.currentError = null;
        this.error = null;
        this.currentSettings = Object.assign({}, dnaR_datePicker_model_1.DefaultSettings);
        this.currentValue = null;
        this.isValidate = false;
        this.validate = false;
        this.onComponentChange = new core_1.EventEmitter();
    }
    get placeholder() {
        return this.currentSettings.placeholder;
    }
    set placeholder(value) {
        if (value != null) {
            this.currentSettings.placeholder = value;
        }
        else {
            this.currentSettings.placeholder = dnaR_datePicker_model_1.DefaultSettings.placeholder;
        }
    }
    set formControlName(value) {
        if (value != null) {
            this.currentControlName = value;
        }
    }
    set duplicateError(value) {
        if (value != null) {
            this.currentSettings.duplicateError = value;
        }
    }
    set required(value) {
        if (value != null) {
            this.currentSettings.isRequired = value;
        }
    }
    set requiredError(value) {
        if (value != null) {
            this.currentSettings.requiredError = value;
        }
    }
    set settings(value) {
        if (value) {
            Object.assign(this.currentSettings, value);
        }
        else {
            Object.assign(this.currentSettings, dnaR_datePicker_model_1.DefaultSettings);
        }
    }
    get value() {
        return this.currentValue;
    }
    set value(value) {
        if (value === undefined) {
            this.currentValue = null;
        }
        else {
            this.currentValue = value;
        }
    }
    writeValue(value) {
        if (value == undefined || value == null) {
            this.currentValue = null;
        }
        else {
            this.currentValue = new Date(value);
        }
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    ngOnChanges() {
        this.currentError = this.error;
        this.currentValue = this.value;
        this.isDisabled = this.disabled;
        this.isValidate = this.validate;
        this.isDuplicate = this.duplicate;
        if (this.validate) {
            this.validateValue();
            this.emitComponentChangeEvent();
        }
    }
    ngAfterViewChecked() {
        if (this.currentValue !== null) {
            this.selectDate(this.currentValue);
        }
    }
    onOpen() {
        this.appendFooter();
    }
    onSetToday() {
        this.selectDate(null);
        this.currentValue = new Date();
        this.selectDate(new Date());
        this.datepicker.close();
    }
    onClear() {
        this.currentValue = null;
        this.selectDate(null);
        this.datepicker.close();
    }
    isValid() {
        return this.validRequired() &&
            this.validDateFormat() &&
            this.noErrors();
    }
    validDateFormat() {
        if (this.currentValue === null) {
            return true;
        }
        return moment(this.currentValue).isValid();
    }
    validRequired() {
        return (!this.currentSettings.isRequired || (this.currentSettings.isRequired && (this.currentValue !== null && this.currentValue !== undefined)));
    }
    noErrors() {
        return (this.currentError === undefined) || (this.currentError === null) || (this.currentError === '');
    }
    inputChanged($event) {
        if ($event === null || $event.value === null || $event.value === undefined || $event.value === '') {
            this.currentValue = null;
            this.onChangeFn(null);
            this.onTouchedFn();
        }
        else if ($event.value) {
            this.currentValue = $event.value;
            this.onChangeFn($event.value);
            this.onTouchedFn();
        }
        this.validateValue();
        this.emitComponentChangeEvent();
    }
    validateValue() {
        if (this.isValidate) {
            this.currentError = null;
            this.hasError = false;
            if (!this.validRequired()) {
                this.currentError = this.currentSettings.requiredError;
                this.hasError = true;
                return;
            }
            if (!this.validDateFormat()) {
                this.currentError = this.currentSettings.formatError;
                this.hasError = true;
                return;
            }
            if (this.isDuplicate) {
                this.currentError = this.currentSettings.duplicateError;
                this.hasError = true;
                return;
            }
        }
    }
    selectDate(selectedDate) {
        if (this.datepicker && selectedDate !== undefined) {
            this.datepicker.select(selectedDate);
            this.cdRef.detectChanges();
        }
    }
    appendFooter() {
        const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0];
        matCalendar.appendChild(this.datepickerActions.nativeElement);
    }
    emitComponentChangeEvent() {
        var EventEmitterValue = (this.currentError !== null && this.currentError !== undefined)
            ? { controlName: this.currentControlName, value: this.currentValue, isInValid: true, error: this.currentError }
            : { controlName: this.currentControlName, value: this.currentValue, isInValid: false, error: null };
        this.onComponentChange.emit(EventEmitterValue);
    }
}
exports.DnaRDatePicker = DnaRDatePicker;
DnaRDatePicker.ɵfac = function DnaRDatePicker_Factory(t) { return new (t || DnaRDatePicker)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
DnaRDatePicker.ɵcmp = i0.ɵɵdefineComponent({ type: DnaRDatePicker, selectors: [["dnaR-date-picker"]], viewQuery: function DnaRDatePicker_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, true);
        i0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datepickerActions = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datepicker = _t.first);
    } }, inputs: { placeholder: "placeholder", formControlName: "formControlName", duplicate: "duplicate", duplicateError: "duplicateError", disabled: "disabled", required: "required", requiredError: "requiredError", error: "error", settings: "settings", value: "value", validate: "validate" }, outputs: { onComponentChange: "onComponentChange" }, features: [i0.ɵɵProvidersFeature([
            { provide: core_2.DateAdapter, useClass: dnaR_datePicker_model_1.AppDateAdapter },
            { provide: core_2.MAT_DATE_FORMATS, useValue: dnaR_datePicker_model_1.DATEPICKER_FORMATS },
            exports.DATEPICKER_CONTROL_VALUE_ACCESSOR
        ]), i0.ɵɵNgOnChangesFeature], decls: 15, vars: 18, consts: [[1, "date-picker-container"], [1, "dnaRComponent", "date-picker", 3, "ngClass"], [1, "date-picker-input", 3, "matDatepicker", "value", "placeholder", "ngClass", "disabled", "dateChange", "dateInput", "blur", "keydown.enter"], [1, "date-picker-toggle", 3, "for", "disableRipple"], [1, "icon", "icon-date-outline"], [3, "disabled", "calendarHeaderComponent", "opened", "blur"], ["datePicker", ""], [4, "ngIf"], [1, "hidden"], [1, "date-picker-buttons"], ["datepickerActions", ""], [1, "today", 3, "click"], [1, "clear", 3, "click"]], template: function DnaRDatePicker_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("dateChange", function DnaRDatePicker_Template_input_dateChange_2_listener($event) { return ctx.inputChanged($event); })("dateInput", function DnaRDatePicker_Template_input_dateInput_2_listener($event) { return ctx.inputChanged($event); })("blur", function DnaRDatePicker_Template_input_blur_2_listener() { return ctx.onTouchedFn(); })("keydown.enter", function DnaRDatePicker_Template_input_keydown_enter_2_listener($event) { return $event.preventDefault(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "mat-datepicker-toggle", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "mat-datepicker", 5, 6);
        i0.ɵɵlistener("opened", function DnaRDatePicker_Template_mat_datepicker_opened_5_listener() { return ctx.onOpen(); })("blur", function DnaRDatePicker_Template_mat_datepicker_blur_5_listener() { return ctx.onTouchedFn(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, DnaRDatePicker_mat_error_7_Template, 2, 1, "mat-error", 7);
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelementStart(9, "div", 9, 10);
        i0.ɵɵelementStart(11, "a", 11);
        i0.ɵɵlistener("click", function DnaRDatePicker_Template_a_click_11_listener() { return ctx.onSetToday(); });
        i0.ɵɵtext(12, "Today");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "a", 12);
        i0.ɵɵlistener("click", function DnaRDatePicker_Template_a_click_13_listener() { return ctx.onClear(); });
        i0.ɵɵtext(14, "Clear");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c2, ctx.isDisabled, ctx.hasError, !ctx.hasError));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matDatepicker", ctx.datepicker)("value", ctx.currentValue)("placeholder", ctx.currentSettings.placeholder)("ngClass", i0.ɵɵpureFunction1(16, _c3, ctx.isDisabled))("disabled", ctx.isDisabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", ctx.datepicker)("disableRipple", true);
        i0.ɵɵattribute("disabled", ctx.isDisabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.isDisabled)("calendarHeaderComponent", ctx.dnaRDatePickerHeaderComponent);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hasError);
    } }, directives: [i1.NgClass, i2.MatDatepickerInput, i2.MatDatepickerToggle, i2.MatDatepicker, i1.NgIf, i3.MatError], styles: ["input[_ngcontent-%COMP%]:focus {\n  outline: none!important;\n}\n.dnaRComponent[_ngcontent-%COMP%] {\n  display: inline-block;\n  border: 1px solid #AAAAAA;\n  border-radius: 2px;\n  float: left;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0;\n}\n.dnaRComponent[_ngcontent-%COMP%]:hover {\n  border-color: #000000;\n}\n.dnaRComponent[_ngcontent-%COMP%]:focus-within {\n  border-color: #008381;\n}\n.valid[_ngcontent-%COMP%] {\n  border-color: #AAAAAA;\n}\n.invalid[_ngcontent-%COMP%] {\n  border-color: #C53535 !important;\n}\n.date-picker[_ngcontent-%COMP%] {\n  width: 100%;\n  height: 34px;\n  text-align: center;\n}\n.date-picker[_ngcontent-%COMP%]:has( > .mat-datepicker-toggle-active)[_ngcontent-%COMP%] {\n  border-color: #008381;\n}\n.date-picker-input[_ngcontent-%COMP%] {\n  display: inline-block;\n  float: left;\n  width: 70%;\n  height: 32px;\n  border: none;\n  padding: 0 0 0 5px;\n}\n.date-picker-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder {\n  \n  color: #757575;\n  opacity: 1;\n  \n}\n.date-picker-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-ms-input-placeholder {\n  \n  color: #757575;\n}\n.date-picker-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-ms-input-placeholder {\n  \n  color: #757575;\n}\n.date-picker-toggle[_ngcontent-%COMP%] {\n  display: inline-block;\n  float: right;\n  width: 29%;\n  height: 34px;\n  color: #949494 !important;\n}\n.mat-datepicker-toggle-active[_ngcontent-%COMP%] {\n  color: #949494;\n  background-color: transparent !important;\n}\n   .cdk-overlay-container {\n  z-index: 3000!important;\n}\n   .mat-icon-button {\n  width: 30px!important;\n  height: 30px!important;\n  line-height: 30px!important;\n  float: right;\n  padding-right: 10px!important;\n}\n   .mat-button-focus-overlay,   .mat-button-focus-overlay {\n  background-color: #ffffff !important;\n}\n.hidden[_ngcontent-%COMP%] {\n  display: none;\n}\n.date-picker-buttons[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding: 15px 20px 10px 20px;\n  width: 310px;\n}\n.date-picker-buttons[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  text-decoration: none;\n  color: #008381;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n}\n.date-picker-buttons[_ngcontent-%COMP%]   .today[_ngcontent-%COMP%] {\n  float: left;\n}\n.date-picker-buttons[_ngcontent-%COMP%]   .clear[_ngcontent-%COMP%] {\n  float: right;\n}\n   .mat-datepicker-content {\n  width: 310px;\n}\n   .mat-datepicker-content .mat-calendar {\n  width: 310px!important;\n}\n   .mat-calendar-table-header th {\n  color: #000000;\n  line-height: 21px;\n  font-weight: 600;\n  font-size: 14px;\n}\n   .mat-calendar-table-header-divider {\n  display: none;\n}\n   .mat-calendar-body-cell-content {\n  border-radius: 5px!important;\n  border: none!important;\n}\n   .mat-calendar-body-selected {\n  background-color: #008381 !important;\n}\n   .mat-calendar-body-today {\n  border: 1px solid #006AD2 !important;\n}\n   .mat-calendar-body-label {\n  visibility: hidden;\n}\n   .mat-calendar-body-label[colspan=\"7\"] {\n  display: none;\n}\n   .mat-error {\n  color: #C53535;\n  float: left;\n  font-size: 12px;\n  padding-bottom: 5px;\n}\n.disabled[_ngcontent-%COMP%] {\n  background-color: #F5F5F5 !important;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DnaRDatePicker, [{
        type: core_1.Component,
        args: [{
                selector: 'dnaR-date-picker',
                templateUrl: './dnaR-datePicker.component.html',
                styleUrls: ['./dnaR-datePicker.component.less'],
                providers: [
                    { provide: core_2.DateAdapter, useClass: dnaR_datePicker_model_1.AppDateAdapter },
                    { provide: core_2.MAT_DATE_FORMATS, useValue: dnaR_datePicker_model_1.DATEPICKER_FORMATS },
                    exports.DATEPICKER_CONTROL_VALUE_ACCESSOR
                ]
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { datepickerActions: [{
            type: core_1.ViewChild,
            args: ['datepickerActions', { static: false }]
        }], datepicker: [{
            type: core_1.ViewChild,
            args: ['datePicker', { static: false }]
        }], placeholder: [{
            type: core_1.Input
        }], formControlName: [{
            type: core_1.Input
        }], duplicate: [{
            type: core_1.Input
        }], duplicateError: [{
            type: core_1.Input
        }], disabled: [{
            type: core_1.Input
        }], required: [{
            type: core_1.Input
        }], requiredError: [{
            type: core_1.Input
        }], error: [{
            type: core_1.Input
        }], settings: [{
            type: core_1.Input
        }], value: [{
            type: core_1.Input
        }], validate: [{
            type: core_1.Input
        }], onComponentChange: [{
            type: core_1.Output
        }] }); })();
